// settingsApi.js

import api from './axios';
import dayjs from 'dayjs';
export const getUserSettings = async (userid) => {
    try {
        const response = await api.get(`/api/user-settings/${userid}`);
        // console.log("User settings fetched:", response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching user settings:', error);
        throw error;
    }
};

export const updateUserSettings = async (userid, settings) => {
    try {
        // console.log("Received settings in API:", settings); // Debug log
        
        // Make sure year_image is included if it's part of your new logic
        const formattedSettings = {
            ...settings,
            userid: userid || settings.userid || '',
            years: settings.years || [dayjs().year(), dayjs().year() - 1],
            advisor1: settings.advisor1 || {},
            advisor2: settings.advisor2 || {},
            advisor3: settings.advisor3 || {},
            year_image: settings.year_image || '' // Add this line if year_image is a new field
        };

        // console.log("Final formatted settings being sent to API:", formattedSettings);
        
        const response = await api.put(`/api/user-settings/${userid}`, formattedSettings);
        return response.data;
    } catch (error) {
        console.error('Error updating user settings:', error);
        throw error;
    }
};


export const uploadUserImage = async (userid, imageType, file) => {
    try {
        const response = await api.post(`/api/user-settings/${userid}/upload-image`, { imageType, file });
        // console.log("RESPONSE:")
        // console.log(response);
        return response.data;
    } catch (error) {
        console.error('Error uploading user image:', error);
        throw error;
    }
};